// extracted by mini-css-extract-plugin
module.exports = {"ArticleActionsHolder":"ArticleActionsHolder_ArticleActionsHolder__3m22J"};